import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from '../InterceptedCoroutine.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../Standard.mjs';
import {
  GeneratorCoroutineImpl2pzxhv55we2g3 as GeneratorCoroutineImpl,
  get_dummyGeneratoryu26m7xm6osk as get_dummyGenerator,
  isGeneratorSuspendStepcb59h14on5am as isGeneratorSuspendStep,
} from '../GeneratorCoroutineImpl.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from './Intrinsics.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
} from '../../Result.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function intercepted(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gd();
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
  throw NotImplementedError().sd('It is intrinsic method');
}
function invokeSuspendSuperType(_this__u8e3s4, completion) {
  throw NotImplementedError().sd('It is intrinsic method');
}
function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
  throw NotImplementedError().sd('It is intrinsic method');
}
function createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = get_dummyGenerator();
  var tmp_0 = get_COROUTINE_SUSPENDED();
  continuation.cd(tmp(tmp_0, () => {
    var it = continuation;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(it) : _this__u8e3s4.td(it);
  }));
  return continuation;
}
function createCoroutineUninterceptedGeneratorVersion_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = get_dummyGenerator();
  var tmp_0 = get_COROUTINE_SUSPENDED();
  continuation.cd(tmp(tmp_0, () => {
    var it = continuation;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, it) : _this__u8e3s4.ud(receiver, it);
  }));
  return continuation;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  continuation.yc_1 = true;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var result = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.ud(receiver, continuation);
  continuation.yc_1 = false;
  if (continuation.dd()) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$4 = _Result___init__impl__xyqfz8(result);
    continuation.tc(tmp$ret$4);
  }
  return result;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion_0(_this__u8e3s4, receiver, param, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  continuation.yc_1 = true;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var result = typeof a === 'function' ? a(receiver, param, continuation) : _this__u8e3s4.vd(receiver, param, continuation);
  continuation.yc_1 = false;
  if (continuation.dd()) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$4 = _Result___init__impl__xyqfz8(result);
    continuation.tc(tmp$ret$4);
  }
  return result;
}
function suspendOrReturn(generator, continuation) {
  var tmp;
  // Inline function 'kotlin.js.asDynamic' call
  if (continuation.constructor === GeneratorCoroutineImpl()) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = continuation;
  } else {
    tmp = new (GeneratorCoroutineImpl())(continuation);
  }
  var generatorCoroutineImpl = tmp;
  var value = generator(generatorCoroutineImpl);
  if (!isGeneratorSuspendStep(value))
    return value;
  // Inline function 'kotlin.js.unsafeCast' call
  var iterator = value;
  generatorCoroutineImpl.cd(iterator);
  try {
    var iteratorStep = iterator.next();
    if (iteratorStep.done) {
      generatorCoroutineImpl.bd();
    }
    return iteratorStep.value;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      generatorCoroutineImpl.bd();
      throw e;
    } else {
      throw $p;
    }
  }
}
//region block: exports
export {
  createCoroutineUninterceptedGeneratorVersion as createCoroutineUninterceptedGeneratorVersion1ji2no4l6ift5,
  createCoroutineUninterceptedGeneratorVersion_0 as createCoroutineUninterceptedGeneratorVersion2gduom218i9ay,
  intercepted as intercepted2ogpsikxxj4u0,
  startCoroutineUninterceptedOrReturnGeneratorVersion as startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn,
  startCoroutineUninterceptedOrReturnGeneratorVersion_0 as startCoroutineUninterceptedOrReturnGeneratorVersion36jld8bkc4ba2,
  suspendOrReturn as suspendOrReturn49pspzlx5djv,
};
//endregion

//# sourceMappingURL=IntrinsicsJs.mjs.map
